/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ChangeCourseRequest } from '../../models/change-course-request';
import { RequestResultApiRespModel } from '../../models/request-result-api-resp-model';

export interface ApiRequestCourseChangeCoursePost$Params {
      body?: ChangeCourseRequest
}

export function apiRequestCourseChangeCoursePost(http: HttpClient, rootUrl: string, params?: ApiRequestCourseChangeCoursePost$Params, context?: HttpContext): Observable<StrictHttpResponse<RequestResultApiRespModel>> {
  const rb = new RequestBuilder(rootUrl, apiRequestCourseChangeCoursePost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<RequestResultApiRespModel>;
    })
  );
}

apiRequestCourseChangeCoursePost.PATH = '/api/Request/Course/ChangeCourse';
